/* Contact form (design-reference/Contact.dc.html): counter, order-number field for "An order", validation, sent message. */
(function () {
  'use strict';
  function init() {
    var box = document.querySelector('[data-psa-contact]');
    var sent = document.querySelector('[data-psa-sent]');
    if (sent) {
      var saved = null; try { saved = JSON.parse(sessionStorage.getItem('psa-contact') || 'null'); } catch (e) {}
      if (saved) {
        var first = (saved.name || '').trim().split(/\s+/)[0] || '';
        var t = sent.getAttribute('data-title'), x = sent.getAttribute('data-text');
        if (first) sent.querySelector('[data-psa-sent-title]').textContent = t.replace('[name]', first);
        if (saved.email) { var p = sent.querySelector('[data-psa-sent-text]'); p.textContent = x.replace('[email]', saved.email); p.hidden = false; }
        try { sessionStorage.removeItem('psa-contact'); } catch (e) {}
      }
    }
    if (!box) return;
    var form = box.closest('form');
    form.noValidate = true;
    var msg = box.querySelector('textarea'), count = box.querySelector('[data-psa-count]');
    var topic = box.querySelector('select'), orderField = box.querySelector('[data-psa-order-field]');
    var consent = box.querySelector('input[type="checkbox"]');
    var errMsg = box.querySelector('[data-psa-err-message]'), errConsent = box.querySelector('[data-psa-err-consent]');
    // The message and consent errors belong to their fields, so screen readers read them with the field (review 9 Oct 2026, finding 10).
    errMsg.id = msg.id + '-err'; errConsent.id = consent.id + '-err';
    function mark(field, err, on) {
      if (on) { field.setAttribute('aria-invalid', 'true'); field.setAttribute('aria-describedby', err.id); }
      else { field.removeAttribute('aria-invalid'); field.removeAttribute('aria-describedby'); }
    }
    msg.addEventListener('input', function () {
      count.textContent = msg.value.length + ' / 2000';
      if (!errMsg.hidden) { errMsg.hidden = true; msg.style.borderColor = 'var(--ink-400)'; mark(msg, errMsg, false); }
    });
    var hint = box.querySelector('[data-psa-topic-hint]'), source = box.querySelector('[data-psa-source]');
    function sync() {
      orderField.hidden = topic.value !== topic.getAttribute('data-order-value');
      if (!hint) return;
      hint.hidden = topic.value !== topic.getAttribute('data-hint-value');
      if (!hint.hidden) topic.setAttribute('aria-describedby', hint.id);
      else if (topic.getAttribute('aria-describedby') === hint.id) topic.removeAttribute('aria-describedby');
    }
    topic.addEventListener('change', sync);
    // Links from the shop and Instagram (28 Oct 2026): ?topic=<value> chooses the topic, ?from=<source> becomes the email's "Source" line.
    var q = new URLSearchParams(location.search), map = {};
    (box.getAttribute('data-topic-map') || '').split('|').forEach(function (p) { var i = p.indexOf('='); if (i > 0) map[p.slice(0, i)] = p.slice(i + 1); });
    if (map[q.get('topic')]) { topic.value = map[q.get('topic')]; sync(); }
    if (source && /^[a-z0-9-]{1,40}$/.test(q.get('from') || '')) { source.value = q.get('from'); source.disabled = false; }
    consent.addEventListener('change', function () { errConsent.hidden = true; mark(consent, errConsent, false); });
    form.addEventListener('submit', function (e) {
      var name = box.querySelector('#PsaContactName'), email = box.querySelector('#PsaContactEmail');
      var ok = true, first = null;
      var bad = function (field) { ok = false; if (!first) first = field; };
      if (!name.value.trim()) { window.psaShowFieldError(name, box.getAttribute('data-err-name')); bad(name); }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { window.psaShowFieldError(email, box.getAttribute('data-err-email')); bad(email); }
      if (!topic.value) { window.psaShowFieldError(topic, box.getAttribute('data-err-topic')); bad(topic); }
      if (msg.value.trim().length < 10) { errMsg.textContent = box.getAttribute('data-err-message'); errMsg.hidden = false; msg.style.borderColor = 'var(--red-600)'; mark(msg, errMsg, true); bad(msg); }
      if (!consent.checked) { errConsent.textContent = box.getAttribute('data-err-consent'); errConsent.hidden = false; mark(consent, errConsent, true); bad(consent); }
      if (!ok) { e.preventDefault(); first.focus(); return; }
      try { sessionStorage.setItem('psa-contact', JSON.stringify({ name: name.value, email: email.value.trim() })); } catch (err) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
